export default __webpack_public_path__ + "static/media/basketIcon.5db6921e.svg";